import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const Overlay = styled(Stack)`
  position: absolute;
  inset: 0;
  z-index: ${VIEWER_Z_INDEX.link};
  padding: 24px;

  /* V1 Intro/CtaFormModal 딤 오버레이와 동일한 컨벤션 */
  background: rgb(79 88 96 / 50%);
`;
